const SERVER_VERSION_KEY = '_version_cloud-s2_szphdl._2.1'
const VERSION_PARAM = '_appVersion'
const VERSION_TIMESTAMP_PARAM = '_appVersionTime'

let verifiedVersion = ''
let checkingPromise = null

function normalizeAssetUrl(url) {
  try {
    const parsedUrl = new URL(url, window.location.origin)
    return parsedUrl.pathname.replace(/^\//, '')
  } catch (error) {
    return url || ''
  }
}

function getAssetUrlsFromDocument(doc) {
  return Array.from(doc.querySelectorAll('script[src], link[rel="stylesheet"][href]'))
    .map((element) => element.getAttribute('src') || element.getAttribute('href'))
    .filter((assetUrl) => assetUrl && assetUrl.indexOf('/static/') !== -1)
    .map(normalizeAssetUrl)
    .sort()
}

function cleanVersionParams() {
  const currentUrl = new URL(window.location.href)
  if (!currentUrl.searchParams.has(VERSION_PARAM) && !currentUrl.searchParams.has(VERSION_TIMESTAMP_PARAM)) {
    return
  }

  currentUrl.searchParams.delete(VERSION_PARAM)
  currentUrl.searchParams.delete(VERSION_TIMESTAMP_PARAM)
  window.history.replaceState(null, document.title, `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`)
}

function reloadWithVersion(version) {
  const currentUrl = new URL(window.location.href)
  currentUrl.searchParams.set(VERSION_PARAM, version)
  currentUrl.searchParams.set(VERSION_TIMESTAMP_PARAM, Date.now())
  window.location.replace(currentUrl.href)
}

function hasReloadedForVersion(version) {
  const currentUrl = new URL(window.location.href)
  return currentUrl.searchParams.get(VERSION_PARAM) === version
}

async function fetchRemoteVersion() {
  const response = await fetch(`/version.json?timestamp=${Date.now()}`, {
    cache: 'no-store',
    headers: {
      'Cache-Control': 'no-cache',
    },
  })

  if (!response.ok) {
    throw new Error('version.json request failed')
  }

  const data = await response.json()
  return data && data.version
}

async function fetchLatestHtmlAssetUrls() {
  const response = await fetch(`/?timestamp=${Date.now()}`, {
    cache: 'no-store',
    headers: {
      'Cache-Control': 'no-cache',
    },
  })

  if (!response.ok) {
    throw new Error('index.html request failed')
  }

  const html = await response.text()
  const doc = new DOMParser().parseFromString(html, 'text/html')
  return getAssetUrlsFromDocument(doc)
}

function isCurrentWindowUsingLatestAssets(latestAssetUrls) {
  const currentAssetUrls = getAssetUrlsFromDocument(document)
  return latestAssetUrls.every((assetUrl) => currentAssetUrls.includes(assetUrl))
}

async function doCheckVersionAndReload() {
  try {
    const remoteVersion = await fetchRemoteVersion()
    if (!remoteVersion) {
      return true
    }

    if (verifiedVersion === remoteVersion) {
      cleanVersionParams()
      return true
    }

    const latestAssetUrls = await fetchLatestHtmlAssetUrls()
    if (isCurrentWindowUsingLatestAssets(latestAssetUrls)) {
      verifiedVersion = remoteVersion
      localStorage.setItem(SERVER_VERSION_KEY, remoteVersion)
      cleanVersionParams()
      return true
    }

    if (hasReloadedForVersion(remoteVersion)) {
      console.warn('Current page assets are still old after reload. Please check index.html cache headers.')
      return true
    }

    reloadWithVersion(remoteVersion)
    return false
  } catch (error) {
    console.error('version check failed:', error)
    return true
  }
}

export async function checkVersionAndReload() {
  if (!checkingPromise) {
    checkingPromise = doCheckVersionAndReload().finally(() => {
      checkingPromise = null
    })
  }

  return checkingPromise
}
